import { AttributeNavigation, AttributeNavigationIconEnum } from "@centricsoftware/design-system";
import { IFormField } from "c8-platform";
import { getAttributeIcon } from "csi/components/icon/iconUtility";
import {
	DragWrapper
} from "designSystem/dnd/index";
import { observer } from "mobx-react-lite";
import React, { FC, FunctionComponent, SVGProps } from "react";
import { useFormDefinitionStore } from "./FormDefinitionStore";

export const FORM_DEFINITION_ATTRIBUTE_DRAG_TYPE = "FormDefinitionAttribute";

export const EditFormDefinitionAttributesList: FunctionComponent = observer(function EditFormDefinitionAttributesList() {
	// const { addAttributeToEnd, transientAttributeGroupMap } = useFormDefinitionStore();
	const { addAttributeToEnd, attributes } = useFormDefinitionStore();

	return (
		<>
			{/* we may bring grouping back for revisable classes */}
			{/* {Object.keys(transientAttributeGroupMap).map((groupKey: string) => {
				const fields = transientAttributeGroupMap[groupKey];
				if (fields.length === 0) {
					return null;
				}
				return (
					<Accordion
						defaultExpanded
						key={groupKey}
						title={groupKey}
					> */}
			{attributes
				.map((formField: IFormField) => {
					const onClick = () => addAttributeToEnd(formField);
					const iconComponentOrText = getAttributeIcon(formField.valueType, formField.format, formField.destinationClassName);
					const key = formField.id;
					return (
						<DragWrapper<IFormField>
							canDrag
							dragItem={formField}
							dragType={FORM_DEFINITION_ATTRIBUTE_DRAG_TYPE}
							key={key}
						>
							<div onClick={onClick}>
								<AttributeNavigation
									{...(typeof iconComponentOrText === "string" 
										? { name: iconComponentOrText as AttributeNavigationIconEnum } 
										: { customIcon: iconComponentOrText as FC<SVGProps<SVGSVGElement>> })}
									isChild
									isSelected={false}
									label={formField.label}
								/>
							</div>
						</DragWrapper>
					);
				})}
			{/* </Accordion>
				);
			})} */}
		</>
	);
},
);
